export default "/react/logoRomi-7220079a.png";